import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import _ from 'lodash';
import { findChildTermsByID, findTaxonomyObjectByName, decodeHTML } from '../../helpers';

class TaxonomyFilter extends Component {
  // Syntax for taxonomy queries: http://dev-jba.colorcrate.com/wp-json/wp/v2/resource?page=1&resourceType=5,6
  constructor(props) {
    super(props);
    this.state = {
      selectOptions: null,
      selectedOption: null,
    };
  };

  componentDidMount() {
    let selectOptions = [];
    let selectedOption = [];
    for (let i=0; i<this.props.taxonomy.length; i++) {
      if (this.props.taxonomy[i].relation === 'parent') {
        selectOptions.push(this.props.taxonomy[i]);
        if (this.props.taxonomy[i].active === true) {
          selectedOption.push(this.props.taxonomy[i]);
        }
      }
    }

    if (selectedOption.length === 0) {
      selectedOption = null;
    }
    else if (selectedOption.length === 1) {
      selectedOption = selectedOption[0];
    }

    this.setState({
      selectOptions: selectOptions,
      selectedOption: selectedOption,
    });
  }

  componentDidUpdate() {
    // See if there's a new selected option, and if so apply it
    let selectedOption = _.cloneDeep(this.state.selectedOption);
    let newSelectedOption = [];
    for (let i=0; i<this.props.taxonomy.length; i++) {
      if (this.props.taxonomy[i].relation === 'parent' && this.props.taxonomy[i].active === true) {
        newSelectedOption.push(this.props.taxonomy[i]);
      }
    }
    if (newSelectedOption.length <= 1) { // If there's only one item in the array, set selectedOption to that item.
      selectedOption = newSelectedOption[0];
    }
    else { // otheriwse, set selectedOption to the array.
      selectedOption = newSelectedOption;
    }

    if (!_.isEqual(selectedOption, this.state.selectedOption)) {
      this.setState({
        selectedOption: selectedOption,
      });
    }
  };

  handleChange = (selectedOption) => {
    if (selectedOption !== null && (selectedOption.length > 0 || typeof selectedOption.length === 'undefined')) {
      this.setState({
        selectedOption: selectedOption,
      }, function(){
        // Callback to send to Archive.js to apply the filter
        this.props.applyFilter({
          action: 'activate',
          obj: selectedOption,
        });
      });
    }
    else { // Null was passed, so deativate the selected option
      this.props.applyFilter({
        action: 'deactivate',
        obj: this.state.selectedOption,
      });
      this.setState({
        selectedOption: selectedOption,
      });
    }
  };

  handleChildChange(e, child) {
    let action = (e.target.checked) ? 'activate' : 'deactivate';
    // Find this child in selectOptions so we can pass bubble it to Archive.js
    for (let i=0; i<this.props.taxonomy.length; i++) {
      if (child.value === this.props.taxonomy[i].value) {
        this.props.applyFilter({
          action: action,
          obj: this.props.taxonomy[i],
        });
      }
    }
  };

  render() {
    // Define child nav
    let children = [];
    if (this.state.selectedOption !== null && typeof this.state.selectedOption !== 'undefined') {
      if (typeof this.state.selectedOption.length === 'undefined') { // If there's more than one selectedOption (ie. multi-select), don't try to fetch children.
        for (let i=0; i<this.props.taxonomy.length; i++) {
          if (this.props.taxonomy[i].parent === this.state.selectedOption.value) {
            children.push(this.props.taxonomy[i]);
          }
        }
      }
    }

    // Multi-select for specific taxonomies (confusing much? I know!)
    if (this.props.taxonomyName === 'capability' || this.props.taxonomyName === 'categories' || this.props.taxonomyName === 'resourceType') {
      return (
        <div className="Sidebar__filter">
          <label htmlFor={this.props.taxonomyName}>{this.props.label}</label>
          <Select
            multi
            backspaceRemoves={false}
            closeOnSelect={false}
            removeSelected={false}
            name={this.props.taxonomyName}
            value={this.state.selectedOption}
            onChange={this.handleChange}
            options={this.state.selectOptions}
            searchable={false}
          />
          {(children.length > 0) && (
            <ul className="Sidebar__filter-children">
              {children.map((item, index) => // Loop through posts and display them
                <li key={index}><input id={item.value} type="radio" name={item.obj.taxonomy + '-radio'} onChange={function(e) { this.handleChildChange(e, item); }.bind(this)} checked={!!item.active} /><label htmlFor={item.value}>{item.label}</label></li>
              )}
            </ul>
          )}
        </div>
      );
    }
    else {
      return (
        <div className="Sidebar__filter">
          <label htmlFor={this.props.taxonomyName}>{this.props.label}</label>
          <Select
            name={this.props.taxonomyName}
            value={this.state.selectedOption}
            onChange={this.handleChange}
            options={this.state.selectOptions}
          />
          {(children.length > 0) && (
            <ul className="Sidebar__filter-children">
              {children.map((item, index) => // Loop through posts and display them
                <li key={index}><input id={item.value} type="radio" name={item.obj.taxonomy + '-radio'} onChange={function(e) { this.handleChildChange(e, item); }.bind(this)} checked={!!item.active} /><label htmlFor={item.value}>{item.label}</label></li>
              )}
            </ul>
          )}
        </div>
      );
    }
  };
};
TaxonomyFilter.propTypes = {
  applyFilter: PropTypes.func,
  name: PropTypes.string,
  query: PropTypes.object,
  taxonomy: PropTypes.array,
};

export default TaxonomyFilter;


// WEBPACK FOOTER //
// ./src/components/filters/TaxonomyFilter.js